import { ActionViewModelValidator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/ActionViewModelValidator';
import { InputViewModelValidator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/InputViewModelValidator';
import { Validator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/Validator';
export class ContentActionViewModelValidator extends Validator {
    constructor() {
        super();
        this.actionViewModelValidator = new ActionViewModelValidator();
        this.inputViewModelValidator = new InputViewModelValidator();
    }
    validate(model) {
        if (model.input) {
            this.inputViewModelValidator.validate(model.input);
        }
        else {
            this.actionViewModelValidator.validate(model.action);
        }
    }
}
